// To generate a new file similar to this one, run `pay js:run gql-v1 --type=mutation --name=<name> --dir=path/to/dir`.
// You can freely edit this file. To update the generated types, run `eslint` in `--fix` mode.
// Do not delete this comment. https://go/gql-operation-definition

import type {
  V1MutationOptions,
  V1MutationOptionsWithoutVariables,
  V1MutationReturn,
  AccountToken,
} from '@stripe-internal/data-v1/types';
/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import {gql} from '@sail/data';
import {useV1Mutation} from '@stripe-internal/data-v1';

import type {
  GraphQlDocument,
  GraphQlFragmentUnion,
  HookVariables,
  GraphQlVariables,
} from '@sail/data';

import type {
  Exact,
  InputMaybe,
  OpenapiPostV1CryptoInternalSetupSessionCryptoSetupSessionUpdateInput,
  V1ContextInput,
} from '@stripe-internal/data-v1/schema/types';
import {setupSessionFragment} from 'src/api/graphql/setupSessionFragment';

import type {
  SetupSessionFragmentData,
  SetupSessionFragmentToken,
  SetupSessionFragmentVariables,
} from 'src/api/graphql/setupSessionFragment';

const doc = gql`
  mutation UpdateSetupSessionMutation(
    $input: OpenapiPostV1CryptoInternalSetupSessionCryptoSetupSessionUpdateInput
    $v1Context: V1ContextInput!
  ) {
    v1CryptoInternalSetupSessionCryptoSetupSessionUpdate(
      input: $input
      v1Context: $v1Context
    ) {
      id
      ...SetupSessionFragment
    }
  }
  ${setupSessionFragment}
`;

export const updateSetupSessionMutation: UpdateSetupSessionMutationDocument =
  doc;

// Fill these options as needed. Options are documented at
// http://go/sail/apis/data/graphql-usage/the-basics-runtime#operation-options
const updateSetupSessionMutationOptions: V1MutationOptionsWithoutVariables<UpdateSetupSessionMutationDocument> =
  {
    fetchPolicy: 'no-cache',
  };

export default function useUpdateSetupSessionMutation<
  THookVariables extends HookVariables<UpdateSetupSessionMutationVariables> = {},
>(
  options: V1MutationOptions<
    UpdateSetupSessionMutationDocument,
    THookVariables
  > = {},
): V1MutationReturn<UpdateSetupSessionMutationDocument, THookVariables> {
  return useV1Mutation(updateSetupSessionMutation, {
    ...updateSetupSessionMutationOptions,
    ...options,
  });
}

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type UpdateSetupSessionMutationVariables = GraphQlVariables<
  Exact<{
    input?: InputMaybe<OpenapiPostV1CryptoInternalSetupSessionCryptoSetupSessionUpdateInput>;
    v1Context: V1ContextInput;
  }>,
  [SetupSessionFragmentVariables]
>;

export type UpdateSetupSessionMutationData = {
  readonly __typename: 'Mutation';
  readonly v1CryptoInternalSetupSessionCryptoSetupSessionUpdate: GraphQlFragmentUnion<
    {
      readonly __typename: 'OpenapiCryptocurrencyPayinsResourceCryptoSetupSession';
      readonly id: string;
    },
    [SetupSessionFragmentData]
  > | null;
};

export type UpdateSetupSessionMutationToken = SetupSessionFragmentToken &
  AccountToken<{
    Mutation_v1CryptoInternalSetupSessionCryptoSetupSessionUpdate: true;
  }>;

export type UpdateSetupSessionMutationDocument = GraphQlDocument<
  UpdateSetupSessionMutationData,
  UpdateSetupSessionMutationVariables,
  UpdateSetupSessionMutationToken
>;
